/* ─────────────────────────────────────────────────────────────
   layout.js — single source of truth for all page layout constants
   Import into every page/section file that needs a content wrapper.
   ───────────────────────────────────────────────────────────── */

/** Full-width content wrapper — use on every page section */
export const WRAP = {
  maxWidth: 1536,
  margin: '0 auto',
  padding: '0 clamp(16px,1.5vw,24px)',
  boxSizing: 'border-box',
};

/** Narrower wrapper for text-heavy pages (blog, legal, contact) */
export const WRAP_NARROW = {
  maxWidth: 860,
  margin: '0 auto',
  padding: '0 clamp(16px,1.5vw,24px)',
  boxSizing: 'border-box',
};

/** Section vertical rhythm — consistent top/bottom padding across all sections */
export const SECTION_PAD = 'clamp(72px,9vh,120px)';